import React, { useEffect } from "react";
import Grid from "@mui/material/Grid2";
import Button from "@mui/material/Button";
import DownloadIcon from "@mui/icons-material/Download";
import Navigation from "../../Components/Navigation";
import { Card, CardContent, Typography, CardMedia } from "@mui/material";
import Footer from "../../Components/Footer";
import ContactRibbon from "../../Components/ContactRibbon";
import evinstonMap from "../../Images/evinston-map.jpg";
import fullMap from "../../Images/full-area-map.jpg";
import hawthorneMap from "../../Images/Hawthorne-map.jpg";
import micanopyMap from "../../Images/Micanopy-map.jpg";
import monteochaMap from "../../Images/monteocha-map-1.jpg";
import waldoMap from "../../Images/waldo-map.jpg";
import windsorMap from "../../Images/windsor-map.jpg";
import HeroAlt from "../../Components/HeroAlt";

import micanopyMapSQ from "../../Images/Micanopy_map_sq.jpg";
import hawthorneMapSQ from "../../Images/Hawthorne_map_sq.jpg";
import evinstonMapSQ from "../../Images/evinston_map_sq.jpg";
import monteochaMapSQ from "../../Images/monteocha_map_sq.jpg";
import waldoMapSQ from "../../Images/waldo_map_sq.jpg";
import windsorMapSQ from "../../Images/windsor_map_sq.jpg";
import fullMapSQ from "../../Images/full_area_map_sq.jpg";

const styles = {
  iframeContainer: {
    display: "flex",
    justifyContent: "center", // horizontal center
    alignItems: "center", // vertical center
    height: "100vh", // take full viewport height
    width: "100vw", // take full viewport width
    boxSizing: "border-box",
  },
  iframe: {
    width: "80vw",
    height: "90vh",
    border: "2px solid black",
  },
};

export default function NewMaps() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Maps";
  }, []);
  return (
    <main>
      <Navigation />

      <HeroAlt title="View Maps of Eastern Alachua County" />

      <section>
        <Grid
          container
          size={12}
          justifyContent="center"
          padding="2% 0"
          spacing={2}
          backgroundColor="#f4f4f4"
        >
          {/*MEETINGS SECTION */}
          <Grid item size={{ xs: 11, sm: 11, md: 10, lg: 9, xl: 9 }} container>
            <Grid size={12} padding="1% 0">
              <p>
                Maps are tools for visualizing communities, sparking
                conversations about local issues, and identifying key community
                assets. Below, you'll find maps highlighting the municipalities
                and unincorporated areas in eastern Alachua County.{" "}
              </p>
            </Grid>
          </Grid>
        </Grid>
      </section>
      <div style={styles.iframeContainer}>
        <iframe
          src="//maps.alachuacounty.us/portal/apps/Embed/index.html?webmap=f452016ba1074477b8b783896c9b9ab0&extent=-82.3636,29.4032,-81.802,29.6896&zoom=true&previewImage=false&scale=true&legend=true&disable_scroll=true&theme=light"
          title="Forward Focus Community Listening Session Map Comments"
          style={styles.iframe}
        ></iframe>
      </div>

      {/* CODE FOR THE CONTACT US RIBBON */}
      <section className="contact-container">
        <ContactRibbon />
      </section>

      <Footer />
    </main>
  );
}
